import type { DBRecord } from '../services/PreferencesDB.ts';

export type MoodValue = 'great' | 'good' | 'neutral' | 'bad' | 'awful';

export class Mood implements DBRecord {
  id: string = crypto.randomUUID();
  createdAt: number = Date.now();
  lastModified: number = Date.now();
  value: MoodValue = 'neutral';
  note: string = '';

  toPlain(): object {
    return {
      id: this.id,
      createdAt: this.createdAt,
      lastModified: this.lastModified,
      value: this.value,
      note: this.note,
    };
  }

  // Map mood values to emoji representations
  static getMoodEmoji(value: MoodValue): string {
    const emojiMap: Record<MoodValue, string> = {
      great: '😄',
      good: '🙂',
      neutral: '😐',
      bad: '😔',
      awful: '😢',
    };
    return emojiMap[value];
  }

  // Get a color associated with the mood
  static getMoodColor(value: MoodValue): string {
    const colorMap: Record<MoodValue, string> = {
      great: '#4CAF50', // Green
      good: '#8BC34A', // Light Green
      neutral: '#FFC107', // Amber
      bad: '#FF9800', // Orange
      awful: '#F44336', // Red
    };
    return colorMap[value];
  }

  // Get a text description of the mood
  static getMoodText(value: MoodValue): string {
    const textMap: Record<MoodValue, string> = {
      great: 'Great',
      good: 'Good',
      neutral: 'Neutral',
      bad: 'Bad',
      awful: 'Awful',
    };
    return textMap[value];
  }
}
